import { render, staticRenderFns } from "./dialogRelatedSet.vue?vue&type=template&id=4fe5ade6&"
import script from "./dialogRelatedSet.vue?vue&type=script&lang=js&"
export * from "./dialogRelatedSet.vue?vue&type=script&lang=js&"
import style0 from "./dialogRelatedSet.vue?vue&type=style&index=0&id=4fe5ade6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports